<div class="cmdk-empty">
  <div class="cmdk-empty__head">
    <span class="cmdk-empty__glyph" aria-hidden="true">
      <paper-icon name="command" [size]="16" />
    </span>
    <div>
      <p class="cmdk-empty__title">{{ heading() }}</p>
      <p class="cmdk-empty__sub">{{ subheading() }}</p>
    </div>
  </div>

  <p class="cmdk-empty__label">{{ listLabel() }}</p>
  <ul class="cmdk-empty__list">
    @for (hint of hints(); track hint.text) {
      <li class="cmdk-empty__row">
        <span class="cmdk-empty__keys">
          @for (cap of hint.keys; track cap.keys) {
            <paper-kbd [keys]="cap.keys" [mod]="cap.mod" [label]="cap.label" size="sm" />
          }
        </span>
        <span class="cmdk-empty__text">{{ hint.text }}</span>
      </li>
    }
  </ul>
</div>
